<div
  class="container"
  [ngClass]="{ 'thick-border': isSelected }"
  gtm="onOpen"
  gtmAction="backup details"
  gtmCategory="vddBackups"
  (click)="showBackupDetails()"
>
  <div class="body">
    <div class="created-at-date">{{ backup.createdAt | date: 'short' }}</div>
  </div>
</div>
